__turbopack_context__.v({
  "className": "hakgyoansimdunggeunmisobold_46dc399d-module__pF8mJa__className",
  "variable": "hakgyoansimdunggeunmisobold_46dc399d-module__pF8mJa__variable",
});
